var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 65,
    viewBox: "0 0 40 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 5C29.9408 5 37.9995 13.1514 37.9995 23.2067C37.9995 26.5233 37.1253 29.631 35.5909 32.3111C34.568 34.0977 29.3709 43.2007 19.9998 59.62C10.6286 43.2007 5.43157 34.0977 4.40865 32.3111C2.87427 29.631 2 26.5233 2 23.2067C2 13.1514 10.0588 5 19.9998 5ZM19.9998 15.4038C15.7393 15.4038 12.2856 18.8973 12.2856 23.2067C12.2856 27.5161 15.7393 31.0095 19.9998 31.0095C24.2602 31.0095 27.714 27.5161 27.714 23.2067C27.714 18.8973 24.2602 15.4038 19.9998 15.4038Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0003,
    cy: 24.1995,
    r: 9.59988,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L23.2328 17.5504L30.4616 18.6008L25.2308 23.6996L26.4656 30.8992L20 27.5L13.5344 30.8992L14.7692 23.6996L9.53838 18.6008L16.7672 17.5504L20 11Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStar);
export default __webpack_public_path__ + "static/media/map-star.852ed030a918cb50a01fee4f067a3b3f.svg";
export { ForwardRef as ReactComponent };